import { ZfCard, ZfCardContent, ZfCardMedia, ZfIcon, ZfTypography } from '@zafire/react';
import moment from 'moment/moment';
import type { FunctionComponent } from 'react';
import { DEFAULT_INPUT_DATE_FORMAT } from '../../config/constants';
import type { RoadmapEvent } from '../../interfaces/event';
import { formatCashFlowAmount } from '../../utils/renderUtils';
import { getZfLifeEventIconForTile } from '../icons/iconUtils';

interface IProps {
    lifeEvent: RoadmapEvent;
    images: Record<string, string>;
}

export const EventCard: FunctionComponent<IProps> = ({ lifeEvent, images }) => {
    const topicImageDataUri = lifeEvent.topicKey ? `data:image/jpeg;base64,${images[lifeEvent.topicKey]}` : '';

    return (
        <ZfCard style={{ width: '170px', padding: '5px 5px 0 5px' }} orientation="vertical" clickable={false}>
            <ZfCardMedia image={topicImageDataUri}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        color: 'white',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            color: 'white',
                            gap: '8px',
                            alignItems: 'center',
                        }}
                    >
                        <ZfIcon name={getZfLifeEventIconForTile(lifeEvent.topicKey)} />
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <ZfTypography variant="body-medium" style={{ fontSize: '18px', color: 'var(--fg-color-default-invert)' }}>
                                {moment(lifeEvent.dueDate).format(DEFAULT_INPUT_DATE_FORMAT)}{' '}
                            </ZfTypography>
                        </div>
                    </div>
                </div>
            </ZfCardMedia>
            <ZfCardContent
                style={{
                    paddingRight: '5px',
                }}
            >
                <ZfTypography
                    style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        WebkitBoxOrient: 'vertical',
                        paddingRight: '5px',
                    }}
                    variant="body-medium"
                    weight="bold"
                >
                    {lifeEvent.name}
                </ZfTypography>

                {lifeEvent.isCashFlowRelevant && (
                    <div className={'event-card__amount'}>{formatCashFlowAmount(lifeEvent.signedAmount!, lifeEvent.type, lifeEvent.currency)}</div>
                )}
            </ZfCardContent>
        </ZfCard>
    );
};
